// Feedback #64 (2026-10-07): a keeper photographed an API Calcium tube that
// was still purple and asked "does this look okay?". A drop or syringe kit
// gives its answer as a count against the kit's own chart, so the tube's
// colour alone says nothing, and the app's photo reader handles only Hanna
// checkers, strips and refractometers (server/vision.js).
export const DROP_KIT_PARAMS = new Set(['alk', 'calcium', 'magnesium']);

export const DROP_KIT_HINT =
  "Drop or syringe kit (API, Salifert, Red Sea)? Keep adding reagent until the colour change in the instructions, then work out the result from your drop count or syringe. The colour halfway through isn't the answer.";

// A keeper who names a Hanna checker in the Kit field reads a screen, not a
// tube: the line would be noise on every entry (Kai, docs/KEEPER-STORIES.md).
export function dropKitHint(param, kit = '') {
  if (!DROP_KIT_PARAMS.has(param)) return null;
  // "HI772" is a Hanna checker by its model number.
  if (/hanna|checker|\bhi ?\d{3}\b/i.test(String(kit || ''))) return null;
  return DROP_KIT_HINT;
}
